// extracted by css-extract-rspack-plugin
export default {"reviewRoot":"IGFCIn0WwSc8b3V9","reviewButton":"MIEr4jCo6E9OGOz1"};